import React from 'react';
import classNames from 'classnames';
import { useTheme } from '@thd-olt-component-react/theme-provider';
import { string, bool } from 'prop-types';
import {
  params,
  string as stringType,
  shape as shapeType
} from '@thd-nucleus/data-sources';
import { useProductDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import './productbar.style.scss';

export const ProductInfoBar = ({ itemId, showOnMobile }) => {
  if (!itemId) {
    return null;
  }

  const theme = useTheme(ProductInfoBar, { itemId, showOnMobile });
  // const { data, loading, error } = useDataModel('product', { variables: { itemId } });
  const { data, loading, error } = useProductDeprecated({ itemId, domains: ['identifiers'] });
  if (!data?.product) {
    return null;
  }

  const { showUpcCode } = theme?.props || {};
  const { product } = data || {};
  const { identifiers } = product || {};
  const {
    modelNumber, storeSkuNumber, specialOrderSku, toolRentalSkuNumber, upc
  } = identifiers;

  const productInfoBarClasses = classNames('product-info-bar', {
    'product-info-bar__mobile': showOnMobile
  });

  return (
    <div className={productInfoBarClasses}>
      <h2 className="product-info-bar__detail">
        Internet #
        {itemId}
      </h2>
      {modelNumber
        && (
          <h2 className="product-info-bar__detail">
            Model #
            {modelNumber}
          </h2>
        )}
      {upc && showUpcCode
        && (
          <h2 className="product-info-bar__detail">
            UPC Code #
            {upc}
          </h2>
        )}
      {storeSkuNumber
        && (
          <h2 className="product-info-bar__detail">
            Store SKU #
            {storeSkuNumber}
          </h2>
        )}
      {specialOrderSku
        && (
          <h2 className="product-info-bar__detail">
            Store SO SKU #
            {specialOrderSku}
          </h2>
        )}
      {toolRentalSkuNumber
        && (
          <h2 className="product-info-bar__detail">
            Rental SKU #
            {toolRentalSkuNumber}
          </h2>
        )}
    </div>
  );
};

ProductInfoBar.themeProps = {
  showUpcCode: bool
};

ProductInfoBar.defaultThemeProps = {
  showUpcCode: false
};

ProductInfoBar.displayName = 'ProductInfoBar';

ProductInfoBar.defaultProps = {
  showOnMobile: false,
};

ProductInfoBar.propTypes = {
  itemId: string.isRequired,
  showOnMobile: bool,
};

ProductInfoBar.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    identifiers: shapeType({
      modelNumber: stringType(),
      storeSkuNumber: stringType(),
      specialOrderSku: stringType(),
      toolRentalSkuNumber: stringType(),
      upc: stringType()
    })
  })
};
